import * as api from "../../api/generated-api";
import React from "react";
import { Stack, Typography } from "@mui/material";

export const OrganizationName = (props: { organization: api.Organization }) => {
  const { organization } = props;
  return (
    <Stack>
      <Typography variant={"subtitle2"}>Name</Typography>
      <Typography variant={"body1"}>{organization.name}</Typography>
    </Stack>
  );
};
